module.exports = "https://cdn.hellotech.com/client-assets/surface_brick_30edabfcc07b8962f3eaeb74061eaaef.png";